import React from "react";
import { Provider } from "react-redux";
import store from "./reducers/store";
import {
	AuthenticatedTemplate,
	UnauthenticatedTemplate,
} from "@azure/msal-react";
import SignIn from "components/SignIn";
import Router from "components/Router";
import { HashRouter, Route, Switch } from "react-router-dom";
import SignedOut from "./components/SignedOut";

const App = () => {
	return (
		<Provider store={store}>
			{process.env.REACT_APP_ENVIRONMENT === "AZURE" ? (
				<>
					<AuthenticatedTemplate>
						<Router />
					</AuthenticatedTemplate>
					<UnauthenticatedTemplate>
						<HashRouter>
							<Switch>
								<Route path="/SignedOut">
									<SignedOut />
								</Route>
								<Route>
									<SignIn />
								</Route>
							</Switch>
						</HashRouter>
					</UnauthenticatedTemplate>
				</>
			) : (
				<Router />
			)}
		</Provider>
	);
};

export default App;
